// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest, putRequest, deleteRequest, getRequestWithNoToken ,postRequestGangAn} from '@/libs/axios';

// 礼包兑换接口
export const getActivation = (params) => {
    return getRequest('/activityRegisterActivation/activation', params)
}
// GET /bqjvip/activityRegisterActivation/myActivityGiftSummary
// 我礼包业务次数汇总
export const getMyActivityGiftSummary = (params) => {
    return getRequest('/activityRegisterActivation/myActivityGiftSummary', params)
}

// 文件上传接口
export const uploadFile = "/bqjvip/upload/file"
// 验证码渲染图片接口
export const drawCodeImage = "/bqjvip/common/captcha/draw/"
// 获取菜单
export const getMenuList = "/bqjvip/permission/getMenuList"
// 获取数据字典
export const getDictData = "/bqjvip/dictData/getByType/"



// 登陆
export const login = (params) => {
    return postRequest('/login', params)
}
// 获取用户登录信息
export const userInfo = (params) => {
    return getRequest('/user/status', params)
}
// 注册
export const regist = (params) => {
    return postRequest('/user/register', params)
}
// 初始化验证码
export const initCaptcha = (params) => {
    return getRequestWithNoToken('/common/captcha/init', params)
}
// 发送短信验证码
export const sendSms = (mobile, params) => {
    return getRequest(`/common/captcha/sendSms/${mobile}`, params)
}
// 短信验证码登录
export const smsLogin = (params) => {
    return postRequest('/user/smsLogin', params)
}
// IP天气信息
export const ipInfo = (params) => {
    return getRequest('/common/ip/info', params)
}
// 个人中心编辑
export const userInfoEdit = (params) => {
    return postRequest('/user/edit', params)
}
// 个人中心修改密码
export const changePass = (params) => {
    return postRequest('/user/modifyPass', params)
}
// 解锁
export const unlock = (params) => {
    return postRequest('/user/unlock', params)
}
//第三方用户绑定
export const bindUser = (params) => {
    return postRequest('/third/bindUser', params)
}
//忘记密码
export const _forgetPassword = (params) => {
    return postRequest('/user/forgetPassword', params)
}

// github登录
export const githubLogin = (params) => {
    return getRequest('/social/github/login', params)
}
// qq登录
export const qqLogin = (params) => {
    return getRequest('/social/qq/login', params)
}
// 微博登录
export const weiboLogin = (params) => {
    return getRequest('/social/weibo/login', params)
}
// 绑定账号
export const relate = (params) => {
    return postRequest('/social/relate', params)
}
// 获取JWT
export const getJWT = (params) => {
    return getRequest('/social/getJWT', params)
}



// 获取绑定账号信息
export const relatedInfo = (username, params) => {
    return getRequest(`/relate/getRelatedInfo/${username}`, params)
}
// 解绑账号
export const unRelate = (params) => {
    return postRequest('/relate/delByIds', params)
}
// 分页获取绑定账号信息
export const getRelatedListData = (params) => {
    return getRequest('/relate/findByCondition', params)
}



// 获取用户数据 多条件
export const getUserListData = (params) => {
    return getRequest('/user/getByCondition', params)
}
// 获取用户数据 多条件
export const getUserListData2 = (params) => {
    return getRequest('/hatch/tUser/getByPage', params)
}

// 获取全部用户数据
export const getAllUserData = (params) => {
    return getRequest('/user/getAll', params)
}
// 添加用户
export const addUser = (params) => {
    return postRequest('/user/admin/add', params)
}
// 编辑用户
export const editUser = (params) => {
    return postRequest('/user/admin/edit', params)
}
// 启用用户
export const enableUser = (id, params) => {
    return postRequest(`/user/admin/enable/${id}`, params)
}
// 禁用用户
export const disableUser = (id, params) => {
    return postRequest(`/user/admin/disable/${id}`, params)
}
// 删除用户
export const deleteUser = (ids, params) => {
    return deleteRequest(`/user/delByIds/${ids}`, params)
}
// 重置用户密码
export const resetUserPass = (params) => {
    return postRequest('/user/resetPass', params)
}



// 获取一级部门
export const initDepartment = (params) => {
    return getRequest('/department/getByParentId/0', params)
}
// 加载部门子级数据
export const loadDepartment = (id, params) => {
    return getRequest(`/department/getByParentId/${id}`, params)
}
// 通过部门获取全部用户数据
export const getUserByDepartmentId = (id, params) => {
    return getRequest(`/user/getByDepartmentId/${id}`, params)
}
// 添加部门
export const addDepartment = (params) => {
    return postRequest('/department/add', params)
}
// 编辑部门
export const editDepartment = (params) => {
    return postRequest('/department/edit', params)
}
// 删除部门
export const deleteDepartment = (ids, params) => {
    return deleteRequest(`/department/delByIds/${ids}`, params)
}
// 搜索部门
export const searchDepartment = (params) => {
    return getRequest('/department/search', params)
}



// 获取全部角色数据
export const getAllRoleList = (params) => {
    return getRequest('/role/getAllList', params)
}
// 分页获取角色数据
export const getRoleList = (params) => {
    return getRequest('/role/getAllByPage', params)
}
// 添加角色
export const addRole = (params) => {
    return postRequest('/role/save', params)
}
// 编辑角色
export const editRole = (params) => {
    return postRequest('/role/edit', params)
}
// 设为或取消注册角色
export const setDefaultRole = (params) => {
    return postRequest('/role/setDefault', params)
}
// 分配角色权限
export const editRolePerm = (params) => {
    return postRequest('/role/editRolePerm', params)
}
// 分配角色数据权限
export const editRoleDep = (params) => {
    return postRequest('/role/editRoleDep', params)
}
// 删除角色
export const deleteRole = (ids, params) => {
    return deleteRequest(`/role/delAllByIds/${ids}`, params)
}



// 获取全部字典
export const getAllDictList = (params) => {
    return getRequest('/dict/getAll', params)
}
// 添加字典
export const addDict = (params) => {
    return postRequest('/dict/add', params)
}
// 编辑字典
export const editDict = (params) => {
    return postRequest('/dict/edit', params)
}
// 删除字典
export const deleteDict = (ids, params) => {
    return deleteRequest(`/dict/delByIds/${ids}`, params)
}
// 搜索字典
export const searchDict = (params) => {
    return getRequest('/dict/search', params)
}
// 获取全部字典数据
export const getAllDictDataList = (params) => {
    return getRequest('/dictData/getByCondition', params)
}
// 添加字典数据
export const addDictData = (params) => {
    return postRequest('/dictData/add', params)
}
// 编辑字典数据
export const editDictData = (params) => {
    return postRequest('/dictData/edit', params)
}
// 删除字典数据
export const deleteData = (ids, params) => {
    return deleteRequest(`/dictData/delByIds/${ids}`, params)
}
// 通过类型获取字典数据
export const getDictDataByType = (type, params) => {
    return getRequest(`/dictData/getByType/${type}`, params)
}



// 获取全部权限数据
export const getAllPermissionList = (params) => {
    return getRequest('/permission/getAllList', params)
}
// 添加权限
export const addPermission = (params) => {
    return postRequest('/permission/add', params)
}
// 编辑权限
export const editPermission = (params) => {
    return postRequest('/permission/edit', params)
}
// 删除权限
export const deletePermission = (ids, params) => {
    return deleteRequest(`/permission/delByIds/${ids}`, params)
}
// 搜索权限
export const searchPermission = (params) => {
    return getRequest('/permission/search', params)
}


// 分页获取日志数据
export const getLogListData = (params) => {
    return getRequest('/log/getAllByPage', params)
}
// 删除日志
export const deleteLog = (ids, params) => {
    return deleteRequest(`/log/delByIds/${ids}`, params)
}
// 清空日志
export const deleteAllLog = (params) => {
    return deleteRequest('/log/delAll', params)
}



// 分页获取Redis数据
export const getRedisData = (params) => {
    return getRequest('/redis/getAllByPage', params)
}
// 通过key获取Redis信息
export const getRedisByKey = (key, params) => {
    return getRequest(`/redis/getByKey/${key}`, params)
}
// 获取Redis键值数量
export const getRedisKeySize = (params) => {
    return getRequest('/redis/getKeySize', params)
}
// 获取Redis内存
export const getRedisMemory = (params) => {
    return getRequest('/redis/getMemory', params)
}
// 获取Redis信息
export const getRedisInfo = (params) => {
    return getRequest('/redis/info', params)
}
// 添加编辑Redis
export const saveRedis = (params) => {
    return postRequest('/redis/save', params)
}
// 删除Redis
export const deleteRedis = (params) => {
    return deleteRequest('/redis/delByKeys', params)
}
// 清空Redis
export const deleteAllRedis = (params) => {
    return deleteRequest('/redis/delAll', params)
}



// 分页获取定时任务数据
export const getQuartzListData = (params) => {
    return getRequest('/quartzJob/getAllByPage', params)
}
// 添加定时任务
export const addQuartz = (params) => {
    return postRequest('/quartzJob/add', params)
}
// 编辑定时任务
export const editQuartz = (params) => {
    return postRequest('/quartzJob/edit', params)
}
// 暂停定时任务
export const pauseQuartz = (params) => {
    return postRequest('/quartzJob/pause', params)
}
// 恢复定时任务
export const resumeQuartz = (params) => {
    return postRequest('/quartzJob/resume', params)
}
// 删除定时任务
export const deleteQuartz = (ids, params) => {
    return deleteRequest(`/quartzJob/delByIds/${ids}`, params)
}



// 分页获取消息数据
export const getMessageData = (params) => {
    return getRequest('/message/getByCondition', params)
}
// 添加消息
export const addMessage = (params) => {
    return postRequest('/message/add', params)
}
// 编辑消息
export const editMessage = (params) => {
    return postRequest('/message/edit', params)
}
// 删除消息
export const deleteMessage = (ids, params) => {
    return deleteRequest(`/message/delByIds/${ids}`, params)
}
// 分页获取消息推送数据
export const getMessageSendData = (params) => {
    return getRequest('/messageSend/getByCondition', params)
}
// 编辑发送消息
export const editMessageSend = (params) => {
    return putRequest('/messageSend/update', params)
}
// 删除发送消息
export const deleteMessageSend = (ids, params) => {
    return deleteRequest(`/messageSend/delByIds/${ids}`, params)
}



// base64上传
export const base64Upload = (params) => {
    return postRequest('/upload/file', params)
}

export const registerVipConfigSave = (params) => {
    return postRequest('/registerVipConfig/save', params)
}

export const registerVipConfigSave2 = (params) => {
    return postRequest('/registerVipConfig/save2', params)
}

export const registerVipConfigPage = (params) => {
    return getRequest('/registerVipConfig/findPage', params);
}

export const registerVipConfigDelete = (ids, params) => {
    return deleteRequest('/registerVipConfig/delByIds/'+ids, params);
}


// 获取指定业务类型加油包列表
export const _findFuelList = (ids,params) => {
    return getRequest('/registerVipConfig/findFuelList'+ids, params);
}

//首页，个人VIP和企业VIP合并
export const _findIndexPageShowNewNew=(params)=>{
    return getRequest('/registerVipConfig/findIndexPageShowNewNew',params);
}


// 网站配置 全局金额配置
//获取各种业务的价格,其中
//bizType 为 01:存证,02:电子版权登记,03:取证,04:监测,05:法律服务,06:平台活动,07:充值,08:会员开通,09:版权交易,10:购买加油包,11:法律服务-出具律师函,12:提现,13:电子公证,14:确权超值套餐,15:优惠券,16:活动套餐,17:预登记,9999:其他业务 
//subBizType为0101:DCI存证,0102:司法存证,0201:DCI登记,0202:贵州登记,0203:甘肃登记,0211:纸质版权登记,0212:证书查询,0213:证书撤销,0214:作品变更,0301:网页取证,0401:图片监测,0402:文字监测,0403:音视频监测,0501:问律师服务（30分钟）,0502:问律师服务（60分钟）,0503:合同审核,0504:侵权下架,0505:侵权判定,0506:出具律师函,0601:红包获得,0602:赠送红包,0603:佣金,0701:充值,0801:会员开通（因为会员是有配置表，所以描述信息可以从配置表中读取）,0807:7天试用会员,08072:美奥中国设计奖会员,08073:好友专享Plus会员,08074:ip动漫超市会员,08075:上海会展会员,1401:单证申请,1402:双证申请,1403:三证申请,1501:购买优惠券,1601:春节活动,1602:426活动;
export const configGetBzPrice =(params)=>{
    return getRequest('/config/getBzPrice',params);
}
// 港安支付接口 支付序列号 paySeqNo
export const getPayInfoByPaySeqNo =(params)=>{
    return getRequest('/paymentBusiness/getPayInfoByPaySeqNo',params);
}

// 港安支付接口 根据业务订单号 orderSeqNo
export const getPayInfoByOrderSeqNo =(params)=>{
    return getRequest('/paymentBusiness/getPayInfoByOrderSeqNo',params);
}

// 港安支付 获取支付订单状态pay
export const getPayStatusByPaySeqNo =(params)=>{
    return getRequest('/paymentBusiness/getPayStatusByPaySeqNo',params);
}
// 港安支付 获取支付订单状态order
export const getPayStatusByOrderSeqNo =(params)=>{
    return getRequest('/paymentBusiness/getPayStatusByOrderSeqNo',params);
}

// 港安更新登记订单加急信息(生成支付订单前更新)
export const updateUrgentInfo = (params)=>{
    return postRequestGangAn('/front/copyrightregister/updateUrgentInfo',params)
}

// 港安第三方跳转
export const getGsfwUrl = (params)=>{
    return postRequest('/user/getGsfwUrl',params)
    
}